import * as _ from "lodash";
import { getCouponMinOrderModeOverride } from "./coupon-min-order.helpers";

// Display-only mirror of how calculate-final-price treats the coupons of a cart
// whose lines are all products on offer (line.promo). The server stays
// authoritative; this only decides whether to show the red
// "cart-products-cant-get-coupon" text above the coupons.
//
// A coupon without a product (fixed, percent, combined or item discount)
// discounts only the lines that are not on offer (calculatePromotions,
// subtotalNoPromos), so in such a cart it gives nothing, and when the order
// ends with no discount the server unticks every selected coupon (index.js,
// after discount_amount). A coupon with a product (a gift or a classic offer)
// is exempt from that reset: the server still adds its product. It is blocked
// by the products on offer only through its minimum, when the store's minimum
// leaves them out (storeInfo.couponsUseSubtotalNoPromos): in such a cart that
// basis is 0, and failsMinimumAtZero below applies the server's check to it.
//
// So the text shows only when every cart line is on offer, some coupon is
// blocked by the products on offer, and no coupon that is not blocked is
// ticked. A ticked gift hides it whatever the promo flag of its own line: a
// gift product can itself be on offer (promo_onlydelivery).

// The minimum check of couponMinOrder.js isCouponMinOrderValid for a basis of 0:
// a mode override fails when it is above 0; the legacy value fails when it is
// set and parseFloat of it is not <= 0 ("0.00" passes, "null" fails).
function failsMinimumAtZero(coupon: any, deliveryMethod: string): boolean {
  const override = getCouponMinOrderModeOverride(coupon, deliveryMethod);

  if (override !== null) {
    return override > 0;
  }

  return (
    !!coupon.appliesToOrderGreaterThan &&
    !(parseFloat(coupon.appliesToOrderGreaterThan) <= 0)
  );
}

export function isCouponBlockedByPromoCart(
  coupon: any,
  storeInfo: any,
  deliveryMethod: string
): boolean {
  if (!coupon.product_id) {
    return true;
  }

  return !!(
    storeInfo &&
    storeInfo.couponsUseSubtotalNoPromos &&
    failsMinimumAtZero(coupon, deliveryMethod)
  );
}

export function shouldShowPromoCartCouponsWarning(
  cartProducts: any[],
  activeCoupons: any[],
  storeInfo: any,
  deliveryMethod: string
): boolean {
  if (
    _.isEmpty(cartProducts) ||
    _.some(cartProducts, (product) => !product || !product.promo)
  ) {
    return false;
  }

  const coupons = _.compact(activeCoupons);

  return (
    _.some(coupons, (coupon) =>
      isCouponBlockedByPromoCart(coupon, storeInfo, deliveryMethod)
    ) &&
    !_.some(
      coupons,
      (coupon) =>
        coupon.couponCheckbox &&
        !isCouponBlockedByPromoCart(coupon, storeInfo, deliveryMethod)
    )
  );
}
